import React from 'react';
import { 
  HelpCircle, 
  Key, 
  Eye, 
  ShieldAlert, 
  Filter, 
  Cpu, 
  Lock,
  AlertTriangle
} from 'lucide-react';

/**
 * Компонент боковой панели с советами по безопасности паролей
 */
const SecurityTipsSidebar = () => {
  const tips = [
    {
      icon: Key,
      title: 'Надежность пароля',
      description: 'Используйте пароли длиной не менее 12 символов, включающие буквы разного регистра, цифры и спецсимволы.'
    },
    {
      icon: Eye,
      title: 'Хранение паролей',
      description: 'Никогда не храните пароли в открытом виде. Используйте хеширование с солью.'
    },
    {
      icon: ShieldAlert,
      title: 'Защита от атак',
      description: 'Bcrypt с 10+ раундами надежно защищает от атак перебором и радужных таблиц.'
    },
    {
      icon: Filter,
      title: 'Соль (Salt)',
      description: 'Bcrypt автоматически добавляет случайную соль к каждому паролю перед хешированием.'
    },
    {
      icon: Cpu,
      title: 'Выбор количества раундов',
      description: 'В 2024 году рекомендуется использовать минимум 10-12 раундов для балансировки безопасности и производительности.'
    },
    {
      icon: Lock,
      title: 'Проверка пароля',
      description: 'Проверяйте пароли, сравнивая их с хешами, а не хеши между собой.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-blue-500" />
        Советы по безопасности
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-100 dark:border-yellow-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <AlertTriangle className="w-5 h-5 text-yellow-600 dark:text-yellow-400 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-yellow-700 dark:text-yellow-300 mb-2">
              Важно: соответствие ФЗ-152
            </h4>
            <p className="text-xs text-yellow-600 dark:text-yellow-400 mb-3">
              При работе с персональными данными граждан РФ следует соблюдать требования Федерального закона "О персональных данных" от 27.07.2006 N 152-ФЗ.
            </p>
            <a 
              href="https://rkn.gov.ru/personal-data/p908/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-xs bg-yellow-200 dark:bg-yellow-800 text-yellow-800 dark:text-yellow-200 py-1 px-2 rounded inline-block hover:bg-yellow-300 dark:hover:bg-yellow-700 transition-colors"
            >
              Подробнее на сайте Роскомнадзора
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityTipsSidebar;